import { getRecords, bySlug, byIds } from './baserow'

function flattenAuthorIds (authors) {
  return (authors || []).reduce((ids, group) => {
    return ids.concat(Array.isArray(group) ? group : [group])
  }, []).filter(author => author != null).map(author => {
    return typeof author === 'object' ? author.id : author
  }).filter(id => id != null)
}

export default {

  getAuthors () {
    return getRecords('Authors')
  },
  getAuthorsById (authorIdList) {
    const orderedIds = flattenAuthorIds(authorIdList)
    return getRecords('Authors', byIds(orderedIds)).then(response => ({
      data: { records: this.sortAuthorList(response.data.records, orderedIds) }
    }))
  },

  async getAuthorList (authors) {
    try {
      const response = await this.getAuthorsById(flattenAuthorIds(authors))
      return response.data.records
    } catch (err) {
      console.log(err)
      return []
    }
  },

  setupAuthor (response) {
    const author = {
      name: response.fields ? response.fields.name : response.value,
      institution: response.fields ? response.fields.institution : undefined,
      url: response.fields ? response.fields.url : undefined,
      id: response.id
    }
    return author
  },

  sortAuthorList (authorList, sorting) {
    const order = new Map(flattenAuthorIds(sorting).map((id, index) => [String(id), index]))
    return authorList.slice().sort((a, b) => {
      const aIndex = order.has(String(a.id)) ? order.get(String(a.id)) : Number.MAX_SAFE_INTEGER
      const bIndex = order.has(String(b.id)) ? order.get(String(b.id)) : Number.MAX_SAFE_INTEGER
      return aIndex - bIndex
    })
  },

  getCourses () {
    return getRecords('Courses')
  },
  getCourse (slug) {
    return getRecords('Courses', bySlug(slug))
  },

  getPapers () {
    return getRecords('Papers')
  },
  getPaper (slug) {
    return getRecords('Papers', bySlug(slug))
  },
  getPapersById (paperIdList) {
    return getRecords('Papers', byIds(paperIdList))
  },

  getMediaById (mediaIdList) {
    return getRecords('Media', byIds(mediaIdList))
  },

  getNews () {
    return getRecords('News')
  },
  getPeople () {
    return getRecords('People')
  },
  getPerson (slug) {
    return getRecords('People', r => r.fields.Name === slug)
  },
  getProjects () {
    return getRecords('Projects')
  },
  getProject (slug) {
    return getRecords('Projects', bySlug(slug))
  },
  getEvents () {
    return getRecords('Events')
  },
  getEvent (slug) {
    return getRecords('Events', bySlug(slug))
  },
  getSlideshow () {
    return getRecords('Slideshow')
  }

}
